import { useTranslations } from 'next-intl'

import ViverseButton from '@/components/ViverseButton'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { Link } from '@/i18n/navigation'
import { isGoogleAdEnabledByGenre } from '@/lib/advertising'

function WorldGenres() {
  const t = useTranslations()
  const { roomData } = useCheckEnterRoomContext()
  const genres = (roomData.tags || []).filter((genre) => !isGoogleAdEnabledByGenre([genre]))

  if (!genres || genres.length === 0) {
    return null
  }

  return (
    <div className="flex w-full gap-4">
      <span className="subheader-3 text-vive-primary-30">{t('world-info.genre')}</span>
      <div className="flex flex-wrap gap-2">
        {genres?.map((genre, index) => (
          <Link href={`/user-worlds?genre=${genre}`} key={`${genre}-${index}`}>
            <ViverseButton
              variant="filter"
              className="caption bg-vive-primary-70 min-w-fit rounded-[5px] px-3 py-1 text-[14px]"
            >
              {genre}
            </ViverseButton>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default WorldGenres
